import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import PulseLoader from '../../../components/PulseLoader';
import { setProcoreSidePanelState } from '../../../redux/modules/procoreSidePanel';
import ProcoreOauthButton from '../ProcoreOauthButton';

const Landing = props => {
  const dispatch = useDispatch();
  const [procoreCompanyId, setProcoreCompanyId] = useState(null);
  const [procoreProjectId, setProcoreProjectId] = useState(null);
  const [procoreResourceId, setProcoreResourceId] = useState(null);
  const [procoreView, setProcoreView] = useState(null);

  const originUrls = [
    'https://us02.procore.com/',
    'https://app.procore.com/',
    'https://sandbox.procore.com/'
  ];

  window.addEventListener('message', event => {
    const obj = event.data;

    if (obj.type === 'setup') {
      const {
        company_id: eventCompanyId,
        project_id: eventProjectId,
        view: eventView,
        id: eventResourceId
      } = obj.context;

      if (eventCompanyId) {
        setProcoreCompanyId(eventCompanyId);
      }

      if (eventProjectId) {
        setProcoreProjectId(eventProjectId);
      }

      if (eventView) {
        setProcoreView(eventView);
      }

      if (eventResourceId) {
        setProcoreResourceId(eventResourceId);
      }

      dispatch(setProcoreSidePanelState({
        procoreCompanyId: eventCompanyId,
        procoreProjectId: eventProjectId,
        procoreResourceId: eventResourceId,
        procoreView: eventView
      }));
    }
  });

  const referrerUrl = originUrls.find(url => url === document.referrer);

  if (referrerUrl) {
    window.parent.postMessage({ type: 'initialize' }, referrerUrl);
  } else if (!document.referrer && PINS_ENV === 'local') {
    console.log('PINS_ENV IS LOCAL, only pull from sandbox');
    window.parent.postMessage({ type: 'initialize' }, 'https://sandbox.procore.com/');
  }

  if (!procoreCompanyId || !procoreView) {
    return (
      <Box
        bg="background.main"
        height="100%"
        minHeight="100vh"
        padding={4}
      >
        <Text>Waiting to receive Procore resources...</Text>
        <PulseLoader loading={!procoreCompanyId || !procoreView} />
      </Box>
    );
  }

  return (
    <ProcoreOauthButton
      procoreCompanyId={procoreCompanyId}
      procoreProjectId={procoreProjectId}
      procoreResourceId={procoreResourceId}
      procoreView={procoreView}
    />
  );
};

Landing.propTypes = {};

export default Landing;
